<template>
  <with-loader class="flex flex-col" id="failed-intents" :loading="loading">
    <div class="flex px-5 pt-10 text-xl">
      <span class="font-semibold text-black-soft mr-1">Failed answers</span>
      <span>({{ intents && intents.length }})</span>
    </div>

    <side-list :selected-id="selectedIntent.intent_id"
               :items="intents"
               id-key="intentId"
               @item-selected="$emit('intent-selected', $event)"
    >
      <template #item="{ item, isItemSelected }">
        <div class="flex flex-col p-3">
          <div class="text-sm flex justify-between py-1">
            <span>{{ item.intentId }}</span>
            <span class="text-focus-error font-medium">{{ getFailedExamplesRatio(item.intentId) }}</span>
          </div>

          <span class="whitespace-nowrap truncate font-medium"
                :class="{'text-black-soft': isItemSelected}"
                :title="item.answerName"
          >
            {{ item.answerName }}
          </span>
        </div>
      </template>
    </side-list>
  </with-loader>
</template>

<script>
import SideList from '@/components/common/SideList'
import WithLoader from '@/components/common/WithLoader'
import testReportModule from '@/store/modules/test-report.module'
import answerModule from '@/store/modules/answer.module'

export default {
  name: 'AnswersReportIntents',

  components: { SideList, WithLoader },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    failedIntents: testReportModule.getIntents,
    answerList: answerModule.getAnswerList,
    selectedIntent: testReportModule.getSelectedIntent,

    examples() {
      return this.selectedIntent.examples?.failed_examples
    },

    intents() {
      return this.failedIntents.map(failedIntent => {
        return {
          intentId: failedIntent.intent_id,
          answerName: this.answerList.find(answer => answer.intent.id === failedIntent.intent_id).name
        }
      })
    }
  },

  methods: {
    getFailedExamplesRatio(id) {
      const { examples } = this.intents.find(({ intentId }) => intentId === id) || {}
      return examples ?
        `${examples.failed_examples.length} / ${examples.total}` :
        ''
    }
  }
}
</script>
